import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=0fbff93e&scoped=true"
import script from "./top-header.vue?vue&type=script&lang=js"
export * from "./top-header.vue?vue&type=script&lang=js"
import style0 from "./top-header.vue?vue&type=style&index=0&id=0fbff93e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbff93e",
  null
  
)

export default component.exports